var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroomDeatailPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.075 2.275L22.225 5.425C22.925 6.125 22.925 7.175 22.225 7.875L9.1 21H3.5V15.4L16.625 2.275C17.325 1.575 18.375 1.575 19.075 2.275ZM21 6.65L17.85 3.5L15.225 6.125L18.375 9.275L21 6.65ZM5.25 16.1V19.25H8.4L17.15 10.5L14 7.35L5.25 16.1ZM1.75 24.5V22.75H26.25V24.5H1.75Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomDeatailPencil);
export default __webpack_public_path__ + "static/media/ClassroomDeatail-pencil.5d10080cef104889db7c762e42ce6326.svg";
export { ForwardRef as ReactComponent };